import { Download, Maximize2 } from "lucide-react";
import { Button } from "../../elements/button/button";
import { Image } from "../../elements/image/image";
import { Text } from "../../elements/text/text";
export interface CardDocumentProps {
  id: string;
  titleText: string;
  viewButtonText: string;
  downloadButtonText: string;
  documentImageSrcLink: string;
  documentImageAltText: string;
  onViewClick: () => void;
  onDownloadClick: () => void;
}

export function CardDocument(props: CardDocumentProps) {
  return (
    <div
      className="flex flex-col items-start gap-2 rounded-lg border border-[#E7E5E4] bg-white p-5"
      key={props.id}
    >
      {/* Document Image - Cover */}
      <div className="w-full shrink-0 overflow-hidden rounded-[6px] bg-[#FAFAF9]">
        <Image
          alt={props.documentImageAltText}
          aspectRatio="3:4"
          src={props.documentImageSrcLink}
        />
      </div>

      {/* Document Title - H4 Typography */}
      <div className="flex items-start">
        <Text variant="h4">{props.titleText}</Text>
      </div>

      {/* Action Buttons */}
      <div className="flex shrink-0 gap-2">
        <Button
          aria-label={`${props.viewButtonText}:${props.titleText}`}
          onClick={props.onViewClick}
          variant="default"
        >
          <Maximize2 className="size-4" />
          {props.viewButtonText}
        </Button>

        <Button
          aria-label={`${props.downloadButtonText}: ${props.titleText}`}
          onClick={props.onDownloadClick}
          variant="outline"
        >
          <Download className="size-4" />
          {props.downloadButtonText}
        </Button>
      </div>
    </div>
  );
}
